import SoftPullStatus from '~/constants/softPullStatus';
import { useAcquisitionContext } from '~/context/common/AcquisitionContext';
import useSoftPullStatus from '~/hooks/vdp/selectors/useSoftPullStatus';
import { Wrapper } from './Card.styles';
import PayMonthlyCard from './PayMonthlyCard';
import PayOnceCard from './PayOnceCard';

export default function WithoutSoftPull() {
  const { softPullStatus } = useSoftPullStatus();
  const hasExpiredFinancing = softPullStatus === SoftPullStatus.Expired;
  const { hasGoogleUTMTerm } = useAcquisitionContext();
  const hideMonthlyCard = hasExpiredFinancing || hasGoogleUTMTerm;

  return (
    <Wrapper data-qa="spt-without-softpull">
      <PayOnceCard isSingleColumn={hideMonthlyCard} />
      {hideMonthlyCard ? null : <PayMonthlyCard />}
    </Wrapper>
  );
}
